interface ActivityLogPrint {
    logId: string;
    time: string;
    message: React.ReactNode;
    projectId?: string;
}

interface ActivityLogProps {
    title: string;
    logs: ActivityLogPrint[];
}

const ActivityLog = ({ title, logs }: ActivityLogProps) => {
    return (
        <div className="activity-log">
            <h3 className="activity-log__title">{title}</h3>
            <div className="activity-log__content">
                {logs.map(log => (
                    <div key={log.logId} className="activity-log__log">
                        <span className="activity-log__time">{log.time}</span>
                        <div className="activity-log__bullet"></div>
                        <p className="activity-log__text">{log.message}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActivityLog;
